up.compiler('[alert-message-on-click]', (element, { message }) => {
  element.addEventListener('click', () => {
    alert(message)
  })
})
